import { useRef, useEffect } from "react";
import "../css/Carousel.css";


const Carousel = ({ logos, speed = 0.5 }) => {
  const trackRef = useRef(null);

  useEffect(() => {
    let position = 0;
    let animationFrameId;

    const animate = () => {
      if (trackRef.current) {
        position -= speed; // velocidad del movimiento
        const width = trackRef.current.scrollWidth / 2; // mitad porque duplicamos
        if (Math.abs(position) >= width) {
          position = 0; // reseteo sin cortes
        }
        trackRef.current.style.transform = `translateX(${position}px)`;
      }
      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    return () => cancelAnimationFrame(animationFrameId);
  }, [speed]);

  return (
    <div className="carousel">
      <div className="carousel-track" ref={trackRef}>
        {[...logos, ...logos].map((logo, i) => (
          <div className="carousel-item" key={i}>
            <img src={logo} alt={`logo-${i}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;